import './Card.svelte.css';
/* src/components/Card.svelte generated by Svelte v3.38.2 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	null_to_empty,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import JSONTree from "../../_snowpack/pkg/svelte-json-tree.js";
import { DiffType } from "../enums.js";

function create_if_block_1(ctx) {
	let code;
	let jsontree;
	let current;
	jsontree = new JSONTree({ props: { value: /*before*/ ctx[2] } });

	return {
		c() {
			code = element("code");
			create_component(jsontree.$$.fragment);
			attr(code, "class", "removed svelte-1ib3j8u");
		},
		m(target, anchor) {
			insert(target, code, anchor);
			mount_component(jsontree, code, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(jsontree.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(jsontree.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(code);
			destroy_component(jsontree);
		}
	};
}

// (36:4) {#if after}
function create_if_block(ctx) {
	let code;
	let jsontree;
	let current;
	jsontree = new JSONTree({ props: { value: /*after*/ ctx[3] } });

	return {
		c() {
			code = element("code");
			create_component(jsontree.$$.fragment);
			attr(code, "class", "added svelte-1ib3j8u");
		},
		m(target, anchor) {
			insert(target, code, anchor);
			mount_component(jsontree, code, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(jsontree.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(jsontree.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(code);
			destroy_component(jsontree);
		}
	};
}

function create_fragment(ctx) {
	let article;
	let section0;
	let h3;
	let span;
	let t0_value = /*getIconSymbol*/ ctx[4](/*type*/ ctx[0]) + "";
	let t0;
	let span_class_value;
	let t1;
	let t2;
	let t3;
	let section1;
	let p;
	let t5;
	let t6;
	let current;
	let if_block0 = /*before*/ ctx[2] && create_if_block_1(ctx);
	let if_block1 = /*after*/ ctx[3] && create_if_block(ctx);

	return {
		c() {
			article = element("article");
			section0 = element("section");
			h3 = element("h3");
			span = element("span");
			t0 = text(t0_value);
			t1 = text("\n      -\n      ");
			t2 = text(/*propName*/ ctx[1]);
			t3 = space();
			section1 = element("section");
			p = element("p");
			p.textContent = `${/*printPath*/ ctx[5]}`;
			t5 = space();
			if (if_block0) if_block0.c();
			t6 = space();
			if (if_block1) if_block1.c();
			attr(span, "class", span_class_value = "" + (null_to_empty(`icon type-${/*getIconSymbol*/ ctx[4](/*type*/ ctx[0])}`) + " svelte-1ib3j8u"));
			attr(h3, "class", "title svelte-1ib3j8u");
			attr(section0, "class", "header svelte-1ib3j8u");
			attr(p, "class", "path svelte-1ib3j8u");
			attr(section1, "class", "content svelte-1ib3j8u");
			attr(article, "class", "svelte-1ib3j8u");
		},
		m(target, anchor) {
			insert(target, article, anchor);
			append(article, section0);
			append(section0, h3);
			append(h3, span);
			append(span, t0);
			append(h3, t1);
			append(h3, t2);
			append(article, t3);
			append(article, section1);
			append(section1, p);
			append(section1, t5);
			if (if_block0) if_block0.m(section1, null);
			append(section1, t6);
			if (if_block1) if_block1.m(section1, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*before*/ ctx[2]) if_block0.p(ctx, dirty);
			if (/*after*/ ctx[3]) if_block1.p(ctx, dirty);
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(article);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	
	let { diff } = $$props;

	// SCRIPT
	const { type, propName, propPath, value: { before, after } } = diff;

	const getIconSymbol = type => {
		switch (type) {
			case DiffType.ADDITION:
				return "A";
			case DiffType.REMOVAL:
				return "R";
			case DiffType.CHANGE:
				return "C";
		}
	};

	const printPath = propPath.replaceAll(".", " > ");

	$$self.$$set = $$props => {
		if ("diff" in $$props) $$invalidate(6, diff = $$props.diff);
	};

	return [type, propName, before, after, getIconSymbol, printPath, diff];
}

class Card extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { diff: 6 });
	}
}

export default Card;